import { Avatar, Text } from "@radix-ui/themes";
import { VscKebabVertical } from "react-icons/vsc";
import { RxGrid } from "react-icons/rx";
import useToogle from "hooks/useToggle";
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { CiMenuKebab } from "react-icons/ci";
import { RxPerson } from "react-icons/rx";
import { ParticipantGroupPanel } from "../classroom/components/ParticipantGroupPanel";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { User } from "models/User";

interface ParticipantProps {
  name: string;
  trainerTableName: string | null;
  videoWidth?: number | string;
  videoHeight?: number | string;
  instructorMode?: boolean;
  peerMode?: boolean;
  isAudio?: boolean;
}

const NoParticipantPanel = () => {
  return (
    <>
      <div className="bg-[#96989d] rounded-lg truncate flex justify-center ">
        <div className="text-2xl flex justify-center items-center p-2 text-white">
          <RxPerson />
        </div>
      </div>
    </>
  );
};

const Participant = ({ name, id }: { name?: string; id?: number }) => {
  const lastName = name?.split(" ").pop();
  return (
    <div className="relative p-0.5 flex items-center space-x-2 px-1">
      <Avatar
        radius="large"
        variant="solid"
        fallback={name?.charAt(0) + lastName?.charAt(0)}
        color="gray"
      />

      <VscKebabVertical
        color="white"
        className="absolute right-0 cursor-pointer px-1"
        size={20}
      />
    </div>
  );
};

export const Table = ({ name }: { name: string }) => {
  return (
    <>
      <div className="relative  flex justify-center items-center h-24 bg-purple-100  rounded-lg ">
        <div className=" bg-app-yellow text-app-blue w-full flex justify-around">
          <p className="px-2">{name}</p>
          {/* <div className="py-1">
            <CiMenuKebab />
          </div> */}
        </div>
      </div>
    </>
  );
};

const SeatStructure = ({ tableDetails }: any) => {
  return (
    <div className="flex flex-col space-y-5 w-fit h-full overflow-y-auto ml-8 scrollbar-hide">
      {tableDetails?.map((data: any) => (
        <div key={data.table_name}>
          <div className="flex justify-center pr-4">
            {data.seats.filter((seat: any) => seat.seat_number === 2).length >
              0 ? (
              data.seats
                .filter((seat: any) => seat.seat_number === 2)
                .map((seat: any) => (
                  <div key={seat.participant_name}>
                    <div className="flex w-full my-0.5">
                      <Participant
                        name={seat.participant_name}
                        id={seat.participant_id}
                      />
                    </div>
                  </div>
                ))
            ) : (
              <div className="my-1 mx-0.5">
                <NoParticipantPanel />
              </div>
            )}
            {data.seats.filter((seat: any) => seat.seat_number === 3).length >
              0 ? (
              data.seats
                .filter((seat: any) => seat.seat_number === 3)
                .map((seat: any) => (
                  <div key={seat.participant_name}>
                    <div className="flex w-full my-0.5">
                      <Participant
                        name={seat.participant_name}
                        id={seat.participant_id}
                      />
                    </div>
                  </div>
                ))
            ) : (
              <div className="my-1 mx-0.5">
                <NoParticipantPanel />
              </div>
            )}
          </div>
          <div className="flex pr-4">
            <div className="flex flex-col">
              {data.seats.filter((seat: any) => seat.seat_number === 5).length >
                0 ? (
                data.seats
                  .filter((seat: any) => seat.seat_number === 5)
                  .map((seat: any) => (
                    <div key={seat.participant_name}>
                      <div className="flex w-full my-0.5">
                        <Participant
                          name={seat.participant_name}
                          id={seat.participant_id}
                        />
                      </div>
                    </div>
                  ))
              ) : (
                <div className="my-0.5 mx-1">
                  <NoParticipantPanel />
                </div>
              )}
              {data.seats.filter((seat: any) => seat.seat_number === 7).length >
                0 ? (
                data.seats
                  .filter((seat: any) => seat.seat_number === 7)
                  .map((seat: any) => (
                    <div key={seat.participant_name}>
                      <div className="flex w-full my-0.5">
                        <Participant
                          name={seat.participant_name}
                          id={seat.participant_id}
                        />
                      </div>
                    </div>
                  ))
              ) : (
                <div className="my-0.5 mx-1">
                  <NoParticipantPanel />
                </div>
              )}
            </div>

            <Table name={data.table_name} />

            <div className="flex flex-col">
              {data.seats.filter((seat: any) => seat.seat_number === 6).length >
                0 ? (
                data.seats
                  .filter((seat: any) => seat.seat_number === 6)
                  .map((seat: any) => (
                    <div key={seat.participant_name}>
                      <div className="flex w-full my-0.5">
                        <Participant
                          name={seat.participant_name}
                          id={seat.participant_id}
                        />
                      </div>
                    </div>
                  ))
              ) : (
                <div className="my-0.5 mx-1">
                  <NoParticipantPanel />
                </div>
              )}
              {data.seats.filter((seat: any) => seat.seat_number === 8).length >
                0 ? (
                data.seats
                  .filter((seat: any) => seat.seat_number === 8)
                  .map((seat: any) => (
                    <div key={seat.participant_name}>
                      <div className="flex w-full my-0.5">
                        <Participant
                          name={seat.participant_name}
                          id={seat.participant_id}
                        />
                      </div>
                    </div>
                  ))
              ) : (
                <div className="my-0.5 mx-1">
                  <NoParticipantPanel />
                </div>
              )}
            </div>
          </div>

          {/* Bottom Seats */}

          <div className="flex justify-center pr-4">
            {data.seats.filter((seat: any) => seat.seat_number === 1).length >
              0 ? (
              data.seats
                .filter((seat: any) => seat.seat_number === 1)
                .map((seat: any) => (
                  <div
                    key={seat.participant_name}
                    className={` ${seat.seat_number === 1 && "flex justify-center "
                      }`}
                  >
                    <div className="flex w-full my-0.5">
                      <Participant
                        name={seat.participant_name}
                        id={seat.participant_id}
                      />
                    </div>
                  </div>
                ))
            ) : (
              <div className="my-1 mx-0.5">
                <NoParticipantPanel />
              </div>
            )}

            {data.seats.filter((seat: any) => seat.seat_number === 4).length >
              0 ? (
              data.seats
                .filter((seat: any) => seat.seat_number === 4)
                .map((seat: any) => (
                  <div
                    key={seat.participant_name}
                    className={`${seat.seat_number === 4 && "flex justify-center "
                      } `}
                  >
                    <div className="flex w-full my-0.5">
                      <Participant
                        name={seat.participant_name}
                        id={seat.participant_id}
                      />
                    </div>
                  </div>
                ))
            ) : (
              <div className="my-1 mx-0.5">
                <NoParticipantPanel />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

const ParticpantPanel = () => {
  const [isPanelTileViewOn, onFeedPanel] = useToogle();
  const { trainer, onlineParticipants, batch } = useSelector(
    (state: RootState) => state.live.settings
  );
  const lastName = trainer?.fullname?.split(" ").pop();
  const tables = JSON.parse(batch?.sittingStyle[0].table);
  const profileData = useSelector((state: any) => state?.auth?.user as User);
  const peersArray = useSelector((state: any) => state.live.settings?.peersNew || {});
  const peerList = Object.keys(peersArray).filter(k => k !== 'trainer@vtt');
  const participantCount = peerList.length + 1;

  const sortedTables = useMemo(() => {
    if (!tables?.length || !profileData?.email) return tables;

    const myTable = tables.find((table) =>
      table.seats.some((seat: any) => seat.participant_email === profileData?.email)
    );
    const otherTables = tables.filter(
      (table) =>
        !table.seats.some((seat: any) => seat.participant_email === profileData?.email)
    );

    // Put myTable first if found
    return myTable ? [myTable, ...otherTables] : tables;
  }, [tables, profileData?.email]);


  return (
    <div className="flex flex-col min-w-full h-full overflow-y-auto">
      <div className="flex justify-center bg-[#1E1E2D] text-white text-center py-[5%] px-[2%] w-full rounded-tl-xl gap-5">
        <Text>
          <span className="tracking-wide px-2">Participant</span>
          <span className="text-app-yellow ">{participantCount}</span>/
          <span>{batch?.participants.length}</span>
        </Text>
        {isPanelTileViewOn && <RxGrid onClick={onFeedPanel} size={25} className="inline " />}
        {!isPanelTileViewOn && (<span onClick={onFeedPanel}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_6921_1007)">
              <path d="M22.6975 12.4683L23.9807 6.64416C24.0767 6.20895 23.8015 5.77801 23.3663 5.68254C22.9311 5.58547 22.5007 5.86121 22.4052 6.29642L21.2612 11.4875H16.116C15.6707 11.4875 15.3096 11.8485 15.3096 12.2944C15.3096 12.7403 15.6707 13.1014 16.116 13.1014H16.4216L14.684 17.2151C14.5106 17.6263 14.7021 18.0988 15.1133 18.2722C15.2147 18.3154 15.3224 18.3362 15.4269 18.3362C15.7416 18.3362 16.0403 18.1506 16.1704 17.8428L17.7566 14.0891L20.2724 14.0897L21.8569 17.8428C22.0313 18.2535 22.505 18.4439 22.914 18.2722C23.3247 18.0988 23.5167 17.6257 23.3434 17.2151L21.6063 13.1014H21.9119C22.2884 13.1008 22.6148 12.8384 22.6975 12.4683Z" fill="white" />
              <path d="M7.57765 13.101H7.88325C8.3286 13.101 8.68967 12.7399 8.68967 12.294C8.68967 11.8482 8.3286 11.4871 7.88325 11.4871H2.73807L1.59458 6.29658C1.49805 5.86137 1.06657 5.5851 0.633494 5.6827C0.198817 5.77817 -0.0769221 6.20911 0.01908 6.64432L1.30231 12.4685C1.38391 12.8381 1.71138 13.1015 2.09006 13.1015H2.39567L0.658027 17.2163C0.48469 17.627 0.676695 18.099 1.08737 18.2723C1.49698 18.4451 1.97059 18.2531 2.14446 17.843L3.72903 14.0898L6.24482 14.0893L7.82992 17.843C7.96006 18.1507 8.25873 18.3363 8.5734 18.3363C8.67794 18.3363 8.78461 18.3155 8.88701 18.2723C9.29769 18.099 9.48969 17.6259 9.31635 17.2163L7.57765 13.101Z" fill="white" />
              <path d="M13.2601 16.7217H12.8057V9.76425H17.1418C17.5871 9.76425 17.9487 9.40317 17.9487 8.95783C17.9487 8.51249 17.5871 8.15088 17.1418 8.15088H6.85676C6.41141 8.15088 6.0498 8.51249 6.0498 8.95783C6.0498 9.40264 6.41141 9.76425 6.85676 9.76425H11.1929V16.7217H10.7384C10.2931 16.7217 9.93202 17.0839 9.93202 17.5292C9.93202 17.9746 10.2931 18.3362 10.7384 18.3362H13.2601C13.7065 18.3362 14.0676 17.9746 14.0676 17.5292C14.0676 17.0839 13.7065 16.7217 13.2601 16.7217Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_6921_1007">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        )}
      </div>
      <div className="bg-transparent flex justify-center items-center ">
        {!isPanelTileViewOn && (
          <div className="bg-purple-950 px-10 py-1 rounded-b-full shadow-md shadow-slate-500 overflow-hidden">
            <Trainer isAudio={false} peerMode={true} videoHeight={96} videoWidth={180} name={trainer?.fullname} trainerTableName="On Table 1" />
          </div>
          // <div className="bg-purple-950 px-10 py-1 rounded-b-full shadow-md shadow-slate-500">
          //   <Avatar
          //     src={trainer?.profilePhoto}
          //     variant="solid"
          //     highContrast
          //     radius="large"
          //     color="gray"
          //     size="4"
          //     fallback={trainer?.fullname?.charAt(0) + lastName?.charAt(0)}
          //   />
          // </div>
        )}
        {isPanelTileViewOn && (
          <div className="bg-purple-950 px-10 py-1 rounded-b-full shadow-md shadow-slate-500">
            <Avatar
              variant="solid"
              highContrast
              radius="large"
              color="gray"
              size="4"
              fallback={trainer?.fullname?.charAt(0) + lastName?.charAt(0)}
            />
          </div>
        )}
      </div>
      {!isPanelTileViewOn && (
        <div className="flex flex-col mt-2 h-full w-full px-[1%] items-center scrollbar-hide overflow-y-auto">
          {sortedTables.map((item: any) => (
            <ParticipantGroupPanel
              key={item.table_name}
              table_name={item.table_name}
              participants={[item]}
            />
          ))}
        </div>
      )}

      {isPanelTileViewOn && (
        <div className="flex flex-col justify-center items-center h-[100%] overflow-y-auto ">
          <SeatStructure tableDetails={sortedTables} />
        </div>
      )}
    </div>
  );
};

const Trainer: React.FC<ParticipantProps> = ({
  name = "Trainer Name",
  trainerTableName,
  videoWidth = 192, // Default width in pixels
  videoHeight = 144,
  instructorMode = false,
  peerMode = false,
  isAudio = true,
}) => {
  const [micOn, setMicOn] = useState(false);
  const [videoOn, setVideoOn] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const currentVideoTrackRef = useRef<MediaStreamTrack | null>(null);
  const currentAudioTrackRef = useRef<MediaStreamTrack | null>(null);
  const trainerJoinedtable = useSelector((state: RootState) => state.live.settings.trainerJoinedtable);

  const consumers = useSelector(
    (state: RootState) => state.live.settings.consumers
  );

  const consumersArray: any[] = useMemo(() => {
    return Object.values(consumers || {});
  }, [consumers]);

  // Memoize the consumer finders to avoid recomputing on every render
  const getVideoConsumer = useCallback(() => {
    return consumersArray.find(
      (consumer: any) =>
        consumer.peerId === "trainer@vtt" && consumer.kind === "video"
    );
  }, [consumersArray]);

  const getAudioConsumer = useCallback(() => {
    return consumersArray.find(
      (consumer: any) =>
        consumer.peerId === "trainer@vtt" && consumer.kind === "audio"
    );
  }, [consumersArray]);

  // Separate effects for video and audio to isolate updates
  useEffect(() => {
    const videoConsumer = getVideoConsumer();

    const shouldShowVideo =
      videoConsumer &&
      videoConsumer.track &&
      videoConsumer.track.readyState === "live" &&
      !videoConsumer.locallyPaused &&
      !videoConsumer.remotelyPaused &&
      !(videoConsumer.appData?.share === true);

    if (shouldShowVideo) {
      const newTrack = videoConsumer.track;
      // Only update if the track has changed or is different
      if (currentVideoTrackRef.current?.id !== newTrack.id) {
        setTimeout(() => {
          if (videoRef.current && newTrack) {
            const stream = new MediaStream([newTrack]);
            videoRef.current.srcObject = stream;
            videoRef.current.play().catch((error) => console.error('Trainer Video play error:', error));
            currentVideoTrackRef.current = newTrack;
          }
        }, 100);
      }
      setVideoOn(true);
    } else {
      // Only stop if it was previously on
      if (videoOn) {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.srcObject = null;
        }
        currentVideoTrackRef.current = null;
        setVideoOn(false);
      }
    }
  }, [getVideoConsumer]); // Depend only on the memoized getter

  const getTailwindSize = (size: number | string, isWidth: boolean): string => {
    if (typeof size === 'string') {
      // Validate that it's a Tailwind class or convert percentage to Tailwind
      if (size === '100%') return isWidth ? 'w-full' : 'h-full';
      if (size === '90%') return isWidth ? 'w-full' : 'h-[90%]';
      if (size === '75vh') return isWidth ? 'w-full' : 'h-[75vh]';
      return size;
    }
    const sizeMap: { [key: number]: string } = isWidth
      ? {
        180: 'w-24',
        192: 'w-48',
        128: 'w-32',
        256: 'w-64',
        320: 'w-80',
        384: 'w-96',
      }
      : {
        144: 'h-36',
        96: 'h-24',
        192: 'h-48',
        240: 'h-60',
        288: 'h-72',
        290: 'h-[55vh]',
        300: 'h-[75vh]',
      };
    return sizeMap[size] || (isWidth ? 'w-48' : 'h-36');
  };

  const containerClasses = [
    'relative flex justify-center items-center',
    instructorMode
      ? 'w-[99%] h-[70vh] mobile:w-full mobile:h-[45%]'
      : [
        getTailwindSize(videoWidth, true),
        getTailwindSize(videoHeight, false),
        'mobile:w-48 mobile:h-28 ',
        'tablet:w-56 tablet:h-32',
        'laptop:w-56 laptop:h-32',
        'desktop:w-64 desktop:h-32',
        'largescreen:w-64 largescreen:h-32',
      ].join(' '),
    'ring-2 ring-white shadow-inner rounded-lg',
  ].join(' ');

  const containerClassesNew = [
    'relative flex justify-center items-center',
    instructorMode
      ? 'w-full h-[70vh] mobile:w-full mobile:h-48'
      : [
        getTailwindSize(videoWidth, true),
        getTailwindSize(videoHeight, false),
        'w-24 mobile:h-24 tablet:h-24 laptop:h-24 desktop:h-24'
      ].join(' ')
  ].join(' ');

  // const getDimension = (dim: number | string | undefined, isWidth: boolean = false): string => {
  //   if (dim === undefined) return isWidth ? `${videoWidth}px` : `${videoHeight}px`;
  //   if (typeof dim === 'number') return `${dim}px`;
  //   return dim;
  // };

  // const containerWidth = getDimension(videoWidth, true);
  // const containerHeight = getDimension(videoHeight);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full relative">
      {/* Video/Image container */}
      <div className={peerMode ? containerClassesNew : containerClasses}>
        {videoOn ? (
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className={`${peerMode ? 'mobile:object-cover object-cover rounded w-full h-full' : 'mobile:object-contain object-cover rounded w-full h-full'}`}
          />
        ) : (
          <div className="w-full h-full rounded-lg" style={{ borderRadius: '8px', background: '#5B5D6B' }}>
            <Text className="w-full h-full flex items-center justify-center text-white font-bold mobile:text-sm tablet:text-lg laptop:text-xl bg-radial-gradient bg-blend-multiply rounded-lg" style={{ borderRadius: '8px', background: 'radial-gradient(50% 86.76% at 50% 50%, rgba(33, 32, 37, 0.00) 0%, rgba(33, 32, 37, 0.30) 50%, rgba(33, 32, 37, 0.60) 100%)', backgroundBlendMode: 'multiply', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFF', fontSize: '20px', fontWeight: '700', }}>
              {name
                ?.split(' ')
                ?.map((word: string) => word.charAt(0))
                ?.slice(0, 2)
                ?.join('') || 'TR'}
            </Text>
          </div>
        )}

        {trainerJoinedtable?.isTrainerPresent && (
          <div className="absolute inset-0 bg-black/60 flex flex-col justify-center items-center text-center rounded-lg">
            <p className="text-white font-semibold text-lg">
              Joined on {trainerJoinedtable?.groupName}
            </p>
          </div>
        )}

        {/* Mic and camera indicators */}
        {/* <div className="absolute bottom-1 left-1 flex space-x-2 text-white text-lg">
          {videoOn ? <HiOutlineVideoCamera /> : <HiOutlineVideoCameraSlash />}
          {micOn ? <IoMicOutline /> : <IoMicOffOutline />}
        </div> */}
      </div>
      {/* Trainer name below */}
      {!peerMode && <Text className="text-app-yellow text-sm mobile:text-md tablet:text-lg laptop:text-lg mt-2">{name}</Text>}
      {/* <Text className="text-app-yellow text-sm mobile:text-md tablet:text-lg laptop:text-lg mt-2">{name}</Text> */}

      {/* Audio element */}
      {/* {isAudio && <audio ref={audioRef} autoPlay />} */}
    </div>
  );
};

export default ParticpantPanel;
